import lazyLoading from "./lazyLoading";

export default {
  name: "reports",
  path: "/reports",
  component: lazyLoading("reports/Reports"),
  meta: {
    default: false,
    title: "Izvještaji",
    class: "primary",
    show: true,
    iconClass: "fa fa-area-chart",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/reports.js